import { requestJson } from '../common/http';
import type { WorkItem } from '../common/models';

export const searchWorkItems = async (query: string): Promise<WorkItem[]> => {
    const response = await requestJson<{ items: WorkItem[] }>({
        method: 'GET',
        path: '/ado/work-items',
        query: { queryType: 'ByTitle', q: query.trim() },
    });
    return response.items;
};
